import { Country } from "../Country.js";

/**
 * List of current European Union (EU) member states.
 */
export const euCountries = [
	Country.Austria,
	Country.Belgium,
	Country.Bulgaria,
	Country.Croatia,
	Country.Cyprus,
	Country.Czechia,
	Country.Denmark,
	Country.Estonia,
	Country.Finland,
	Country.France,
	Country.Germany,
	Country.Greece,
	Country.Hungary,
	Country.Ireland,
	Country.Italy,
	Country.Latvia,
	Country.Lithuania,
	Country.Luxembourg,
	Country.Malta,
	Country.Netherlands,
	Country.Poland,
	Country.Portugal,
	Country.Romania,
	Country.Slovakia,
	Country.Slovenia,
	Country.Spain,
	Country.Sweden,
] as const satisfies Country[];

export type EuCountry = (typeof euCountries)[number];
